import { render } from "./RegistrationDeeds.vue?vue&type=template&id=04fba4df"
import script from "./RegistrationDeeds.vue?vue&type=script&lang=js"
export * from "./RegistrationDeeds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__